module.exports = __webpack_public_path__ + "img/Burger Menu_white.77cd47dc.svg";